module.exports = __webpack_public_path__ + "static/media/Tailwind-CSS.c7c8e06d.svg";